import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import SelectDropdown from "../../components-react/SelectDropdown";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../data/APIs";
import { validationRawLeadForm } from "../functions/LeadValidations";
import { fetchInHouseUsersData } from "../../../redux/reducers/dropdownApiSlice";
// import SelectDropdownDynamic from "../../components-react/SelectDropdownDynamic";
import { assignRawLead, reAssignLeads } from "../../../data/ApiEndpoints";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";

const AssignForm = ({
  userInfoData,
  selectedRows,
  closeModal,
  isFromRawLead,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { loading } = useSelector((state) => state.common);
  const { inhouseUsers } = useSelector((state) => state.dropdown);

  const isAdmin = userInfoData?.account_type === "admin";
  const rowData = selectedRows?.[0];

  const iniFormValues = {
    selectedGym:
      rowData?.gym_id && rowData?.gym_name
        ? { label: rowData.gym_name, value: rowData.gym_id }
        : !isAdmin
        ? {
            label: userInfoData?.gym_name,
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedReceptionist: "",
    assignToOtherUsers: false,
    selectedOtherUser: "",
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  // const iniValues = {
  //   page: 1,
  //   search: "",
  // };
  // const [fetchValues, setFetchValues] = useState(iniValues);
  // const [totalPages, setTotalPages] = useState(1);
  const [allReceptionists, setAllReceptionists] = useState([]);

  console.log("selectedRows=> ", selectedRows);

  const onChangeDropdown = (name, value) => {
    if (name === "selectedGym") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        selectedReceptionist: "",
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const onChangeCheckbox = (e) => {
    const { name, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: checked,
      selectedReceptionist: "",
      selectedOtherUser: "",
    }));
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    if (selectedRows?.length === 0) {
      toast.error("");
    } else {
      setFormErrors(validationRawLeadForm(formValues));
      setIsSubmit(true);
    }
  };

  function getReceptionists(qpStr) {
    dispatch(
      fetchInHouseUsersData({
        token: userInfoData?.token,
        qps: qpStr,
        pageNo: 1,
        limit: 1000,
      })
    );
  }

  const handleAdd = async (requestBody) => {
    const method = isFromRawLead ? "POST" : "PUT";
    const endpoint = isFromRawLead ? reAssignLeads : assignRawLead;
    const payload = requestBody;
    const token = userInfoData?.token;

    setIsSubmit(false);

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
      } else {
        const errorMessage = result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  // ********-------------
  // const handleSearchChange = (inputValue) => {
  //   setFetchValues((prev) => ({
  //     ...prev,
  //     page: 1,
  //     search: inputValue,
  //   }));
  // };

  // const fetchMoreData = () => {
  //   if (fetchValues.page + 1 <= totalPages) {
  //     setFetchValues((prev) => ({
  //       ...prev,
  //       page: prev.page + 1,
  //     }));
  //   }
  // };

  // const fetchPreviousData = () => {
  //   setFetchValues((prev) => ({
  //     ...prev,
  //     page: Math.max(prev.page - 1, 1),
  //   }));
  // };
  // ------------------**********

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
  }, []);

  useEffect(() => {
    if (!formValues.assignToOtherUsers) {
      const gymQP = formValues.selectedGym?.value
        ? `gym_id=${formValues.selectedGym.value}`
        : "";
      // const searchQP = fetchValues?.search
      //   ? `&search=${fetchValues?.search}`
      //   : "";
      const userTypeQP = `&user_types=receptionist`;
      const qpStr = gymQP + userTypeQP;

      getReceptionists(qpStr);
    }
  }, [formValues?.selectedGym, formValues.assignToOtherUsers]);

  useEffect(() => {
    if (formValues.assignToOtherUsers) {
      const qpStr = `user_types=admin,cluster_manager,fitness_manager,sales_manager,club_manager`;

      getReceptionists(qpStr);
    }
  }, [formValues.assignToOtherUsers]);

  // useEffect(() => {
  //   if (inhouseUsers?.length > 0) {
  //     const inhouse = inhouseUsers?.[0];
  //     setTotalPages(inhouse?.pagination?.[0]?.pagination || 1);
  //   } else {
  //     setTotalPages(1);
  //   }
  // }, [inhouseUsers]);

  useEffect(() => {
    if (inhouseUsers?.length > 0) {
      // const allReceps = formValues.assignToOtherUsers
      //   ? inhouseUsers
      //   : inhouseUsers?.filter((value) =>
      //       value?.label?.includes("Sales Executive")
      //     );
      setAllReceptionists(inhouseUsers);
    } else {
      setAllReceptionists([]);
    }
  }, [inhouseUsers, formValues.assignToOtherUsers]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const allLeads = selectedRows.map((row) => ({
        lead_id: row?.uid || row?.lead_id,
        gym_id: formValues.assignToOtherUsers
          ? row?.gym_id || ""
          : formValues.selectedReceptionist?.info?.gym_id || "",
      }));

      const userData = {
        assigned_to: formValues.assignToOtherUsers
          ? formValues.selectedOtherUser?.value || ""
          : formValues.selectedReceptionist?.value || "",
        gym_id: formValues.assignToOtherUsers
          ? ""
          : formValues.selectedReceptionist?.info?.gym_id || "",
        lead_details: allLeads,
      };

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `You Want to Re Assign ${selectedRows?.length || 0} Leads?`,
        "No, Cancel",
        "Yes, Re Assign"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="form-container add-new-job">
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          {!formValues.assignToOtherUsers && (
            <div className="formInputBox">
              <label htmlFor="selectedGym" className={`formInputLabel`}>
                Gym
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedGym ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={gymData?.length > 0 ? gymData : []}
                  selectedOption={formValues.selectedGym}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("selectedGym", selectedValue)
                  }
                  name="Gym"
                />
              </div>
            </div>
          )}

          {!formValues.assignToOtherUsers && (
            <div className="formInputBox">
              <label
                htmlFor="selectedReceptionist"
                className={`formInputLabel`}
              >
                Sales Executive <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedReceptionist ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={allReceptionists}
                  selectedOption={formValues.selectedReceptionist}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("selectedReceptionist", selectedValue)
                  }
                  name="Sales Executive"
                  // onSearchChange={handleSearchChange}
                  // fetchMoreData={fetchMoreData}
                  // fetchPreviousData={fetchPreviousData}
                />
              </div>
            </div>
          )}

          {formValues.assignToOtherUsers && (
            <div className="formInputBox span2">
              <label htmlFor="selectedOtherUser" className={`formInputLabel`}>
                Select User <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedOtherUser ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={allReceptionists}
                  selectedOption={formValues.selectedOtherUser}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("selectedOtherUser", selectedValue)
                  }
                  name="User"
                />
              </div>
            </div>
          )}

          <div className="formInputBox span2 mt15">
            <label className="formInputLabel checkboxLabel">
              <input
                type="checkbox"
                name="assignToOtherUsers"
                checked={formValues.assignToOtherUsers}
                onChange={onChangeCheckbox}
              />
              Assign To Other Users
            </label>
          </div>
        </div>

        <CloseSubmitBtn
          submitLabel="Update"
          closeLabel="Cancel"
          onSubmit={onSumitForm}
          onClose={closeModal}
          isLoading={loading}
        />
      </form>
    </div>
  );
};

export default AssignForm;
